import * as Constants from "../common/Constants";

const initialState = {
    clientDiscounts:[],
    dis_IsLoading: false,
    dis_Error: null,
    discounts: [],
    isPosted: false,
    isPosting: false,
    isLoading: false,
    pageSize: 10
};

export default function discountReducer(state = initialState, action) {

    var newState;
    switch (action.type) {
        case Constants.REQUEST_DISCOUNTS:
            newState = { ...state };
            newState.dis_Error = null;
            newState.dis_IsLoading = true;
            return newState;

        case Constants.RECEIVE_DISCOUNTS:
            newState = { ...state };
            newState.dis_Error = null;
            newState.dis_IsLoading = false;
            newState.discounts = action.discounts;
            return newState;

        case Constants.FAILED_DISCOUNTS:
            newState = { ...state };
            newState.dis_Error = action.error;
            newState.dis_IsLoading = false;
            return newState;

        case Constants.REQUEST_ADD_DISCOUNTS:
            newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_ADD_DISCOUNTS:
            newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.FAILED_ADD_DISCOUNTS:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        case Constants.RESET_DISCOUNT_POSTED:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            return newState;

        case Constants.REQUEST_GET_CLIENT_DISCOUNTS:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            return newState;

        case Constants.FAILED_GET_CLIENT_DISCOUNTS:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.SUCCESS_GET_CLIENT_DISCOUNTS:
             
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.clientDiscounts = action.discounts;
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/DiscountReducer.js